module.exports = __webpack_public_path__ + "static/womens-volleyball-with-jimmy-stitz-2bd1c6db43dfa3d0ce41147b961e82c0.jpg";